<template>
<div class="quiz_progress">



<div  class="quiz_progress_home_item">
<template v-if="$route.name=='EvaluationProgress'">
<div class="quiz_progress_item_inner quiz_progress_item_inner_active animate_class"  @click="gotoList()">
<i class="pi pi-list"></i>
</div>
</template>
<template v-else>
<div class="quiz_progress_item_inner animate_class"  @click="gotoList()">
<i class="pi pi-list"></i>
</div>  
</template>
</div>








</div>

</template>

<script>
export default {

  name: 'QuizPreviewProgress',
  data () {
    return {
      loading:false
    }
  },
  methods:{
    gotoList()
    {
      this.$router.push({ name: 'QuestionlistPreviewProgress' })
    },
  }
}
</script>

<style lang="css" scoped>
</style>